import { ApplicationApiTagTypes, ApplicationApiUrls } from "@/modules/application/common/enum";
import type {
  ICreateDepositTerminationApplicationRequest,
  IDepositTerminationApplication,
  IUpdateDepositTerminationApplicationRequest,
} from "@/modules/application/common/types";
import { withIdempotency } from "@/shared/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "app/axios";

export const depositTerminationApplicationApi = createApi({
  reducerPath: "depositTerminationApplicationApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: [ApplicationApiTagTypes.ApplicationHistory],
  endpoints: (builder) => ({
    createDepositTerminationApplication: builder.mutation<string, ICreateDepositTerminationApplicationRequest>(
      withIdempotency<ICreateDepositTerminationApplicationRequest>(
        ApplicationApiUrls.DepositTerminationApplication,
      )),
    updateDepositTerminationApplication: builder.mutation<string, IUpdateDepositTerminationApplicationRequest>(
      {
        query: ({ data, id }) => ({
          url: `${ApplicationApiUrls.DepositTerminationApplication}/${id}`,
          method: "PUT",
          data,
        }),
      }),
    getDepositTerminationApplication: builder.query<IDepositTerminationApplication, {
      id: string
    }>({
      query: ({ id }) => ({
        url: `${ApplicationApiUrls.DepositTerminationApplication}/${id}`,
      }),
    }),
  }),
});

export const {
  useGetDepositTerminationApplicationQuery,
  useCreateDepositTerminationApplicationMutation,
  useUpdateDepositTerminationApplicationMutation,
} = depositTerminationApplicationApi;
